import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueApexCharts from "vue3-apexcharts";
import { installConfirm } from "./composables/useConfirm";
import { installToast } from "./composables/useToast";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./styles/themes.css";
import "./styles/main.css";

const app = createApp(App);

app.use(router);
app.use(VueApexCharts);
installConfirm(app);
installToast(app);

app.mount("#app");
